import {
  faDeleteLeft,
  faPrint,
  faEdit,
  faEye,
  faSheetPlastic,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { secretKey } from "../.././data";
import Loading from "../helpers/loading_component.js";
import SendPostTask from "./sendPostTask";
import ShowPostDetail from "./showPostDetail";
import TaskPopUp from "./task_popup.js";

const MySwal = withReactContent(Swal2);

const PostBookBuffer = (props) => {
  const [loading, setLoading] = useState(true);
  const [buffer, setBuffer] = useState([]);
  const [filter, setFilter] = useState(false);
  const [dateFilterFrom, setDateFilterFrom] = useState("");
  const [dateFilterTo, setDateFilterTo] = useState("");
  const [contentFilter, setContentFilter] = useState("");
  const [bufferClear, setBufferClear] = useState([]);
  const [buffers, setBuffers] = useState([]);
  const [closeSend, setCloseSend] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [numNad, setNumNad] = useState("");
  const [taskNums, setTaskNums] = useState([]);
  const [taskNumberPost, setTaskNumberPost] = useState([]);
  const [descPost, setDescPost] = useState([]);
  const [showTask, setShowTask] = useState(false);
  const [showTaskId, setShowTaskId] = useState("");
  const [showDetails, setShowDetails] = useState(false);
  const [details, setDetails] = useState("");

  const fetchCloseSend = async () => {
    setLoading(true);
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getSendClose ", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var date =
          new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1 < 10
            ? "0" + (new Date().getMonth() + 1)
            : new Date().getMonth() + 1) +
          "-" +
          (new Date().getDate() < 10
            ? "0" + new Date().getDate()
            : new Date().getDate());

        if (date === data.date) {
          setCloseSend(true);
        } else {
          setCloseSend(false);
        }

        fetchTasNumber();
      })
      .catch((error) => {});
  };

  const getFilteredBuffer = () => {
    setFilter(true);
    var arr1 = [];
    bufferClear.map((el) => {
      el.paczki.map((eo) => {
        arr1.push(eo);
      });
    });
    var arr = arr1;

    if (contentFilter.length > 0) {
      arr = arr.filter(
        (el) =>
          el.numNad.includes(contentFilter) ||
          (el.name ? el.name : "")
            .toString()
            .toLowerCase()
            .includes(contentFilter.toString().toLowerCase()) ||
          el.task.includes(contentFilter) ||
          el.addressFull.includes(contentFilter) ||
          (el.desc ? el.desc : "")
            .toString()
            .toLowerCase()
            .includes(contentFilter.toString().toLowerCase())
      );
      var arr2 = [];
      bufferClear.map((el) => {
        var newR = {
          dataNadania: el.dataNadania,
          idBufor: el.idBufor,
          paczki: arr,
        };
        arr2.push(newR);
      });

      setBuffer(arr2);
    }
  };

  const clearFilters = () => {
    setFilter(false);
    setDateFilterFrom("");
    setDateFilterTo("");
    setContentFilter("");
    setBuffer(bufferClear);
  };

  const fetchTasNumber = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getTaskNumberPost", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setTaskNumberPost(data);
        fetchDescPost(data);
      })
      .catch((error) => {});
  };

  const fetchDescPost = async (task) => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getDescPost", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setDescPost(data);
        fetchBufferList(task, data);
      })
      .catch((error) => {});
  };

  const fetchBufferList = async (task, desc) => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getBuforListPostBookList", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setBuffers(
          data.bufor.sort(function (a, b) {
            return (
              new Date(a.attributes.dataNadania) -
              new Date(b.attributes.dataNadania)
            );
          })
        );

        fetchBuffer(data.bufor, task, desc);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const fetchBuffer = async (buffers, task, desc) => {
    var arr = [];
    try {
      if (buffers) {
        buffers.map(async (el) => {
          var body = {
            guid: el.attributes.idBufor,
          };

          await fetch("https://apidevkppp.ftpeople.pl/getBuforListPostBook", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body),
          })
            .then((response) => response.json())
            .then((data) => {
              if (data.przesylka) {
                try {
                  var arr1 = [];

                  data.przesylka.map((ep) => {
                    var newR1 = {
                      task:
                        task.filter(
                          (eq) => eq.guid === ep.attributes.numerNadania
                        ).length > 0
                          ? task.filter(
                              (eq) => eq.guid === ep.attributes.numerNadania
                            )[0].taskId
                          : "nie powiązano",
                      desc:
                        desc.filter(
                          (eq) => eq.guid === ep.attributes.numerNadania
                        ).length > 0
                          ? desc.filter(
                              (eq) => eq.guid === ep.attributes.numerNadania
                            )[0].descA
                          : "",
                      addressFull: `${ep.adres.attributes.ulica} ${ep.adres.attributes.numerDomu} ${ep.adres.attributes.numerLokalu} ${ep.adres.attributes.numerLokalu}, ${ep.adres.attributes.kodPocztowy} ${ep.adres.attributes.miejscowosc}`,
                      name:
                        ep.adres.attributes.nazwa +
                        " " +
                        (ep.adres.attributes.nazwa2
                          ? ep.adres.attributes.nazwa2
                          : ""),
                      numNad: ep.attributes.numerNadania,
                      date: ep.attributes.planowanaDataNadania,
                      przesylka: ep,
                    };

                    arr1.push(newR1);
                  });
                } catch (err) {}

                try {
                  var newR = {
                    dataNadania: el.attributes.dataNadania,
                    idBufor: el.attributes.idBufor,
                    paczki: arr1,
                  };

                  arr.push(newR);
                } catch (err) {}
              } else {
              }
            })
            .catch((error) => {});
        });

        setBuffer(
          arr.sort(function (a, b) {
            return new Date(a.dataNadania) - new Date(b.dataNadania);
          })
        );

        setBufferClear(
          arr.sort(function (a, b) {
            return new Date(a.dataNadania) - new Date(b.dataNadania);
          })
        );
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
    }
  };

  const updateBuffer = async (e) => {
    var body = {
      guid: e.target.value,
    };

    await fetch("https://apidevkppp.ftpeople.pl/updateBuforNewDate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});
  };

  const getData = () => {
    setBuffer([]);
    setLoading(true);
    fetchCloseSend();
  };

  useEffect(() => {
    getData();
  }, []);

  const fetchDeleteEnvelope = async (e) => {
    var guid = e.currentTarget.value;
    MySwal.fire({
      title: "Czy na pewno chcesz usunąć przesyłkę?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        var body = {
          guid: guid,
        };

        await fetch("https://apidevkppp.ftpeople.pl/deleteEnvelope", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {
            MySwal.fire({
              icon: "success",
              title: "Usunięto",
              text: "przesyłkę",
            }).then((result) => {
              getData();
            });
          })
          .catch((error) => {});
      } else if (result.isDenied) {
        setLoading(false);
      }
    });
  };

  const fetchDeleteEnvelopeTask = async (e) => {
    var guid = e.currentTarget.value;
    var task =
      buffer[0].paczki.filter((ex) => ex.przesylka.attributes.guid === guid)
        .length > 0
        ? buffer[0].paczki.filter(
            (ex) => ex.przesylka.attributes.guid === guid
          )[0].task
        : "";
    var number =
      buffer[0].paczki.filter((ex) => ex.przesylka.attributes.guid === guid)
        .length > 0
        ? buffer[0].paczki.filter(
            (ex) => ex.przesylka.attributes.guid === guid
          )[0].przesylka.attributes.numerNadania
        : "";

    MySwal.fire({
      title: "Czy na pewno chcesz usunąć przesyłkę?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        var body = {
          guid: guid,
        };

        await fetch("https://apidevkppp.ftpeople.pl/deleteEnvelope", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then(async (data) => {
            var body2 = {
              id: task,
            };
            await fetch("https://apidevkppp.ftpeople.pl/getTasksId", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(body2),
            })
              .then((response) => response.json())
              .then(async (data) => {
                try {
                  var task = data[0];
                  var postNumber = task.postNumber
                    ? task.postNumber.split("\n")
                    : null;
                  var postGuid = task.postGuid
                    ? task.postGuid.split("\n")
                    : null;
                  var content = "";
                  var content1 = "";

                  if (postNumber) {
                    postNumber.map((el, index) => {
                      if (!el.includes(number)) {
                        content =
                          content +
                          el +
                          (index + 1 === postNumber.length ? "" : "\n");
                      }
                    });
                  } else {
                    content = "";
                  }

                  if (postGuid) {
                    postGuid.map((el, index) => {
                      if (!el.includes(guid)) {
                        content1 =
                          content1 +
                          el +
                          (index + 1 === postGuid.length ? "" : "\n");
                      }
                    });
                  } else {
                    content1 = "";
                  }
                } catch (error) {}

                var body3 = {
                  id: task.id,
                  content: content,
                  content1: content1,
                };

                await fetch("https://apidevkppp.ftpeople.pl/clearTask", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: secretKey,
                  },
                  body: JSON.stringify(body3),
                })
                  .then((response) => response.text())
                  .then((data) => {
                    MySwal.fire({
                      icon: "success",
                      title: "Usunięto",
                      text: "przesyłkę",
                    }).then((result) => {
                      getData();
                    });
                  });
              })
              .catch((error) => {});
          })
          .catch((error) => {});
      } else if (result.isDenied) {
        setLoading(false);
      }
    });
  };

  const fetchSendEnvelope = async (e) => {
    var guid = e.target.value;

    MySwal.fire({
      title: "Czy na pewno chcesz wysłać wszystkie przesyłki do PP?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        var body = {
          guid: guid,
        };

        await fetch("https://apidevkppp.ftpeople.pl/sendEnvelope", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then(async (data) => {
            var body = { guid: data.idEnvelope };

            await fetch("https://apidevkppp.ftpeople.pl/getLabelForPostbook", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(body),
            })
              .then((response) => response.json())
              .then((data) => {
                handleOpenPdfInNewTab(data.pdfContent);
                if (!closeSend) {
                  MySwal.fire({
                    title: "Czy chcesz zamknąć wysyłkę na dzisiaj?",
                    showDenyButton: true,
                    showCancelButton: false,
                    confirmButtonText: "Tak",
                    denyButtonText: `Nie`,
                  }).then(async (result) => {
                    if (result.isConfirmed) {
                      fetchCreateBufor2();
                    } else if (result.isDenied) {
                      var body = {};

                      fetch("https://apidevkppp.ftpeople.pl/getSend", {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                          Authorization: secretKey,
                        },
                        body: JSON.stringify(body),
                      })
                        .then((response) => response.json())
                        .then((data) => {})
                        .catch((error) => {});
                    }
                  });
                } else {
                  var body = {};

                  fetch("https://apidevkppp.ftpeople.pl/getSend", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: secretKey,
                    },
                    body: JSON.stringify(body),
                  })
                    .then((response) => response.json())
                    .then((data) => {})
                    .catch((error) => {});
                }
              })
              .catch((error) => {
                if (!closeSend) {
                  MySwal.fire({
                    title: "Czy chcesz zamknąć wysyłkę na dzisiaj?",
                    showDenyButton: true,
                    showCancelButton: false,
                    confirmButtonText: "Tak",
                    denyButtonText: `Nie`,
                  }).then(async (result) => {
                    if (result.isConfirmed) {
                      fetchCreateBufor2();
                    } else if (result.isDenied) {
                      var body = {};

                      fetch("https://apidevkppp.ftpeople.pl/getSend", {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                          Authorization: secretKey,
                        },
                        body: JSON.stringify(body),
                      })
                        .then((response) => response.json())
                        .then((data) => {})
                        .catch((error) => {});
                    }
                  });
                } else {
                  var body = {};

                  fetch("https://apidevkppp.ftpeople.pl/getSend", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: secretKey,
                    },
                    body: JSON.stringify(body),
                  })
                    .then((response) => response.json())
                    .then((data) => {})
                    .catch((error) => {});
                }
              });
          })
          .catch((error) => {});
      } else if (result.isDenied) {
        setLoading(false);
      }
    });
  };

  const onlyUnique = (value, index, array) => {
    return array.indexOf(value) === index;
  };

  const fetchTasNumberSend = async () => {
    setLoading(true);
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getTaskNumberPost", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        fetchPostFileSend(data);
      })
      .catch((error) => {});
  };

  const fetchPostFileSend = async (task) => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getPostFile", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        fetchDescPostSend(task, data);
      })
      .catch((error) => {});
  };

  const fetchDescPostSend = async (task, files) => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getDescPost", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        fetchSend(task, data, files);
      })
      .catch((error) => {});
  };

  const fetchSend = async (task, desc, files) => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getSendPostList", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then(async (data) => {
        var arr = [];
        var arr2 = [];
        var arr3a = [];
        var arr4a = [];
        data.map(async (e, index) => {
          var body = {
            env: e.attributes.idEnvelope,
          };

          await fetch("https://apidevkppp.ftpeople.pl/getSendPostListDetail", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body),
          })
            .then((response) => response.json())
            .then(async (data) => {
              data.przesylka.map((ex) => {
                arr3a.push(
                  new Date(
                    ex.przesylkaFull.attributes.planowanaDataNadania
                  ).getFullYear()
                );
                arr4a.push(
                  new Date(
                    ex.przesylkaFull.attributes.planowanaDataNadania
                  ).getMonth() + 1
                );
                arr2.push({
                  idEnvelope: e.attributes.idEnvelope,
                  date: ex.przesylkaFull.attributes.planowanaDataNadania,
                  link:
                    files.filter(
                      (f) => f.idEnvelope === e.attributes.idEnvelope
                    ).length > 0
                      ? files.filter(
                          (f) => f.idEnvelope === e.attributes.idEnvelope
                        )[0].link
                      : "",
                });
                var newR = {
                  idEnvelope: e.attributes.idEnvelope,
                  name: ex.przesylkaFull.adres.attributes.nazwa,
                  street: ex.przesylkaFull.adres.attributes.ulica,
                  number: ex.przesylkaFull.adres.attributes.numerDomu,
                  postCode: ex.przesylkaFull.adres.attributes.kodPocztowy,
                  city: ex.przesylkaFull.adres.attributes.miejscowosc,
                  date: ex.przesylkaFull.attributes.planowanaDataNadania,
                  numNad: ex.przesylkaFull.attributes.numerNadania,
                  guid: ex.przesylkaFull.attributes.guid,
                  addressFull: `${ex.przesylkaFull.adres.attributes.ulica} ${ex.przesylkaFull.adres.attributes.numerDomu}, ${ex.przesylkaFull.adres.attributes.kodPocztowy} ${ex.przesylkaFull.adres.attributes.miejscowosc}`,
                  potOdb:
                    +ex.przesylkaFull.attributes.iloscPotwierdzenOdbioru > 0
                      ? "TAK"
                      : "NIE",
                  category: ex.przesylkaFull.attributes.kategoria,
                  task:
                    task.filter(
                      (el1) =>
                        el1.guid === ex.przesylkaFull.attributes.numerNadania
                    ).length > 0
                      ? task.filter(
                          (el1) =>
                            el1.guid ===
                            ex.przesylkaFull.attributes.numerNadania
                        )[0].taskId
                      : "nie powiązano",
                  desc:
                    desc.filter(
                      (el1) =>
                        el1.guid === ex.przesylkaFull.attributes.numerNadania
                    ).length > 0
                      ? desc.filter(
                          (el1) =>
                            el1.guid ===
                            ex.przesylkaFull.attributes.numerNadania
                        )[0].descA
                      : "nie powiązano",
                };

                arr.push(newR);
              });

              var arr4 = [];

              arr2.map((el) => {
                var t = arr4.filter((elx) => elx.idEnvelope === el.idEnvelope);
                if (t.length === 0) {
                  arr4.push(el);
                }
              });

              var body = {
                value: JSON.stringify(arr),
                years: JSON.stringify(
                  arr3a.filter(onlyUnique).sort(function compareNumbers(a, b) {
                    return b - a;
                  })
                ),
                months: JSON.stringify(
                  arr4a.filter(onlyUnique).sort(function compareNumbers(a, b) {
                    return b - a;
                  })
                ),
                postBookDate: JSON.stringify(
                  arr4.sort(function (a, b) {
                    return new Date(b.date) - new Date(a.date);
                  })
                ),
              };

              await fetch("https://apidevkppp.ftpeople.pl/editPostSend", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: secretKey,
                },
                body: JSON.stringify(body),
              });
            });
          if (index + 1 === data.length) {
            setTimeout(() => {
              MySwal.fire({
                icon: "success",
                title: "Wsyłano",
                text: "przesyłki",
              }).then((result) => {
                getData();
              });
            }, 30000);
          }
        });
      })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});
  };

  const fetchCreateBufor = async (e) => {
    var guid = e.currentTarget.value;
    MySwal.fire({
      title: "Czy na pewno zamknąć wysyłkę na dzisiaj?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        var body = {};

        await fetch("https://apidevkppp.ftpeople.pl/createBufor", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {
            MySwal.fire({
              icon: "success",
              title: "Zamknięto",
              text: "wysyłkę, kolejne przesyłki będą dodawane na kolejny dzień.",
            }).then((result) => {
              getData();
            });
          })
          .catch((error) => {});
      } else if (result.isDenied) {
        setLoading(false);
      }
    });
  };

  const fetchCreateBufor2 = async (e) => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/createBufor", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        fetchTasNumberSend();
      })
      .catch((error) => {});
  };

  const fetchOpenSend = async (e) => {
    MySwal.fire({
      title:
        "Czy na pewno otworzyć wysyłkę na dzisiaj? Nie wysłane dziś paczki z planowaną datą nadania na dziś zostaną zauktalizowane i będą wymagały wydruku nowych etykiet jutro.",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        var body = {};

        await fetch("https://apidevkppp.ftpeople.pl/openSend", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {
            MySwal.fire({
              icon: "success",
              title: "Zamknięto",
              text: "wysyłkę, kolejne przesyłki będą dodawane na kolejny dzień.",
            }).then((result) => {
              getData();
            });
          })
          .catch((error) => {});
      } else if (result.isDenied) {
        setLoading(false);
      }
    });
  };

  const fetchPrintLabel = async (e) => {
    var body = {
      guid: e.currentTarget.value,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getLabelByGuid", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        handleOpenPdfInNewTab(data.printResult[0].print);
      })
      .catch((error) => {});
  };

  const fetchPrintLabelMobile = async (e) => {
    var body = {
      guid: e.currentTarget.value,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getLabelByGuid", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        handleDownloadPdfInNewTab(data.printResult[0].print);
      })
      .catch((error) => {});
  };

  const handleDownloadPdfInNewTab = (base64Pdf) => {
    var pdf = `data:application/pdf;base64,${base64Pdf}`;

    const pdfLink = pdf;
    const anchorElement = document.createElement("a");
    const fileName = `raport.pdf`;
    anchorElement.href = pdfLink;
    anchorElement.target = "_blank";
    anchorElement.download = fileName;
    anchorElement.click();
  };

  const handleOpenPdfInNewTab = (base64Pdf) => {
    try {
      var pdfData = `data:application/pdf;base64,${base64Pdf}`;

      var w = window.open("");

      if (w) {
        w.document.write(
          `<embed width="100%" height="100%" src="${pdfData}" type="application/pdf" />`
        );
      } else {
        throw new Error("Failed to open a new tab.");
      }
    } catch (error) {
      console.error("Error opening PDF in new tab:", error);
      // } finally {
      //   if (w) w.document.close();
      // }
    }
  };

  const showEditMode = (e) => {
    setNumNad(e.currentTarget.value);
    setShowEdit(true);
  };

  const showDetailsF = (e) => {
    setNumNad(e.currentTarget.value);
    setShowDetails(true);
  };

  const showTaskPopUp = (e) => {
    setShowTask(true);
    setShowTaskId(e.currentTarget.value);
  };

  const bufferData = (
    <>
      {buffer
        ? buffer.map((ex) => (
            <>
              <div style={{ display: "flex", gap: "2vw", marginTop: "4vh" }}>
                <button
                  className="paymentMenuButton"
                  style={{
                    backgroundColor: "green",
                    color: "white",
                    border: "white",
                  }}
                  value={ex.idBufor}
                  onClick={fetchSendEnvelope}
                >
                  WYŚLIJ PRZESYŁKI i WYGENERUJ KSIĄŻKE NADAWCZĄ
                </button>
              </div>
              <p>
                ID Bufora: {ex.idBufor} | Data nadania: {ex.dataNadania}
              </p>
              <p id="asd4" style={{ textAlign: "right" }}>
                Liczba przesyłek: {ex.paczki ? ex.paczki.length : 0}
              </p>
              <div id="asd2">
                <table className="clients_table">
                  <tr key={0}>
                    <th>Lp.</th>
                    <th>Numer nadania</th>
                    <th>Rodzaj</th>
                    <th>Odbiorca</th>
                    <th>Adres odbiorcy</th>
                    <th>Zadanie</th>
                    <th>Opis</th>
                    <th>Akcja</th>
                  </tr>
                  {!ex.paczki ? (
                    <></>
                  ) : (
                    ex.paczki.map((el, index) => (
                      <>
                        <tr id={""} key={el.id}>
                          <td>{index + 1}</td>
                          <td>{el.przesylka.attributes.numerNadania}</td>
                          <td>{el.przesylka.attributes.kategoria}</td>
                          <td>
                            {el.przesylka.adres.attributes.nazwa +
                              " " +
                              (el.przesylka.adres.attributes.nazwa2
                                ? el.przesylka.adres.attributes.nazwa2
                                : "")}
                          </td>
                          <td>
                            {el.przesylka.adres.attributes.ulica +
                              " " +
                              el.przesylka.adres.attributes.numerDomu +
                              " " +
                              (el.przesylka.adres.attributes.numerLokalu
                                ? el.przesylka.adres.attributes.numerLokalu +
                                  ", "
                                : ", ") +
                              el.przesylka.adres.attributes.kodPocztowy +
                              " " +
                              el.przesylka.adres.attributes.miejscowosc}
                          </td>
                          <td>
                            {" "}
                            {el.task !== "nie powiązano" ? (
                              <>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "10px",
                                  }}
                                >
                                  {el.task}
                                  <button
                                    style={{
                                      width: "10%",
                                      backgroundColor: "transparent",
                                      color: "#a5bea4",
                                      border: "none",
                                      fontSize: "1vw",
                                      textAlign: "center",
                                    }}
                                    id="clientsButton"
                                    className="paymentMenuButton"
                                    value={el.task}
                                    onClick={showTaskPopUp}
                                  >
                                    <FontAwesomeIcon icon={faEye} />
                                  </button>
                                </div>
                              </>
                            ) : (
                              el.task
                            )}
                          </td>
                          <td>{el.desc ? el.desc : "nie powiązano"}</td>
                          <td>
                            {el.task !== "nie powiązano" ? (
                              <>
                                <button
                                  style={{
                                    marginLeft: "10px",
                                    width: "10%",
                                    backgroundColor: "transparent",
                                    color: "#a5bea4",
                                    border: "none",
                                    fontSize: "1vw",
                                  }}
                                  id="clientsButton"
                                  className="paymentMenuButton"
                                  value={el.przesylka.attributes.guid}
                                  onClick={fetchDeleteEnvelopeTask}
                                >
                                  <FontAwesomeIcon icon={faDeleteLeft} />
                                </button>
                              </>
                            ) : (
                              <>
                                <button
                                  style={{
                                    marginLeft: "10px",
                                    width: "10%",
                                    backgroundColor: "transparent",
                                    color: "#a5bea4",
                                    border: "none",
                                    fontSize: "1vw",
                                  }}
                                  id="clientsButton"
                                  className="paymentMenuButton"
                                  value={el.przesylka.attributes.guid}
                                  onClick={fetchDeleteEnvelope}
                                >
                                  <FontAwesomeIcon icon={faDeleteLeft} />
                                </button>
                              </>
                            )}
                            <button
                              style={{
                                marginLeft: "10px",
                                width: "10%",
                                backgroundColor: "transparent",
                                color: "#a5bea4",
                                border: "none",
                                fontSize: "1vw",
                              }}
                              id="clientsButton"
                              className="paymentMenuButton"
                              value={el.przesylka.attributes.guid}
                              onClick={fetchPrintLabel}
                            >
                              <FontAwesomeIcon icon={faPrint} />
                            </button>
                            <button
                              style={{
                                marginLeft: "10px",
                                width: "10%",
                                backgroundColor: "transparent",
                                color: "#a5bea4",
                                border: "none",
                                fontSize: "1vw",
                              }}
                              id="clientsButton"
                              className="paymentMenuButton"
                              value={el.przesylka.attributes.numerNadania}
                              onClick={showEditMode}
                            >
                              <FontAwesomeIcon icon={faEdit} />
                            </button>
                          </td>
                        </tr>
                      </>
                    ))
                  )}
                </table>
              </div>
              <div id="asd3">
                <table className="clients_table">
                  <tr key={0}>
                    <th>Rodzaj</th>
                    <th>Odbiorca</th>
                    <th>Akcja</th>
                  </tr>
                  {!ex.paczki ? (
                    <></>
                  ) : (
                    ex.paczki.map((el, index) => (
                      <>
                        <tr id={""} key={el.id}>
                          <td>{el.przesylka.attributes.kategoria}</td>
                          <td>
                            {el.przesylka.adres.attributes.nazwa +
                              " " +
                              (el.przesylka.adres.attributes.nazwa2
                                ? el.przesylka.adres.attributes.nazwa2
                                : "")}
                          </td>

                          <td>
                            {el.task !== "nie powiązano" ? (
                              <>
                                <button
                                  style={{
                                    marginLeft: "10px",
                                    width: "10%",
                                    backgroundColor: "transparent",
                                    color: "#a5bea4",
                                    border: "none",
                                  }}
                                  id="asd5"
                                  className="paymentMenuButton"
                                  value={el.przesylka.attributes.guid}
                                  onClick={fetchDeleteEnvelopeTask}
                                >
                                  <FontAwesomeIcon icon={faDeleteLeft} />
                                </button>
                              </>
                            ) : (
                              <>
                                <button
                                  style={{
                                    marginLeft: "10px",
                                    width: "10%",
                                    backgroundColor: "transparent",
                                    color: "#a5bea4",
                                    border: "none",
                                  }}
                                  id="asd5"
                                  className="paymentMenuButton"
                                  value={el.przesylka.attributes.guid}
                                  onClick={fetchDeleteEnvelope}
                                >
                                  <FontAwesomeIcon icon={faDeleteLeft} />
                                </button>
                              </>
                            )}
                            <div id="asd2">
                              <button
                                style={{
                                  width: "10%",
                                  backgroundColor: "transparent",
                                  color: "#a5bea4",
                                  border: "none",

                                  textAlign: "center",
                                }}
                                id="asd5"
                                className="paymentMenuButton"
                                value={el.przesylka.attributes.guid}
                                onClick={fetchPrintLabel}
                              >
                                <FontAwesomeIcon icon={faPrint} />
                              </button>
                            </div>
                            <div id="asd3">
                              <button
                                style={{
                                  width: "10%",
                                  backgroundColor: "transparent",
                                  color: "#a5bea4",
                                  border: "none",

                                  textAlign: "center",
                                }}
                                id="asd5"
                                className="paymentMenuButton"
                                value={el.przesylka.attributes.guid}
                                onClick={fetchPrintLabelMobile}
                              >
                                <FontAwesomeIcon icon={faPrint} />
                              </button>
                            </div>

                            <button
                              style={{
                                marginLeft: "10px",
                                width: "10%",
                                backgroundColor: "transparent",
                                color: "#a5bea4",
                                border: "none",
                              }}
                              id="asd5"
                              className="paymentMenuButton"
                              value={el.przesylka.attributes.numerNadania}
                              onClick={showEditMode}
                            >
                              <FontAwesomeIcon icon={faEdit} />
                            </button>
                            <button
                              style={{
                                marginLeft: "10px",
                                width: "10%",
                                backgroundColor: "transparent",
                                color: "#a5bea4",
                                border: "none",
                              }}
                              id="asd5"
                              className="paymentMenuButton"
                              value={el.przesylka.attributes.numerNadania}
                              onClick={showDetailsF}
                            >
                              <FontAwesomeIcon icon={faSheetPlastic} />
                            </button>
                          </td>
                        </tr>
                      </>
                    ))
                  )}
                </table>
              </div>
            </>
          ))
        : "BRAK PRZESYŁEK W BUFORZE"}
    </>
  );

  return (
    <>
      <div className="mainContainerPayments">
        <div
          style={{ width: "100%", marginBottom: "1vh" }}
          className="closeBox"
        >
          <button className="closeClientButton" onClick={props.close}>
            X
          </button>
        </div>
        {loading ? (
          <>
            <Loading />
          </>
        ) : (
          <>
            {showTask ? (
              <>
                <TaskPopUp
                  taskID={showTaskId}
                  hearingsData={props.hearingsData}
                  tasksData={props.tasksData}
                  tasksSheetData={props.tasksSheetData}
                  closeTaskPopUp={() => setShowTask(false)}
                  lawyersData={props.lawyersData}
                  refreshData={props.refreshData}
                  user={props.uData}
                  courtsData={props.courtsData}
                  banksData={props.banksData}
                  usersData={props.users}
                  resultsData={props.resultsData}
                  tasksTypesData={props.tasksTypesData}
                  history={false}
                  checkPermissions={props.checkPermissions}
                  team={props.team}
                  hearingsTeam2Data={props.hearingsTeam2Data}
                  hearingsTeam2SheetData={props.hearingsTeam2SheetData}
                  tasksTeam2Data={props.tasksTeam2Data}
                  tasksTeam2SheetData={props.tasksTeam2SheetData}
                  archTasksTeam2={props.tasksArchTeam2SheetData}
                  archTasks={props.archTasks}
                  logClientAction={props.logClientAction}
                  close={() => setShowTask(false)}
                  tabIndex={0}
                  clientsData={props.clientsFullData}
                  filesData={props.filesData}
                  user={props.user}
                />
              </>
            ) : (
              <>
                {showEdit ? (
                  <>
                    <SendPostTask
                      close={() => {
                        setShowEdit(false);
                        getData();
                      }}
                      mode={"edit"}
                      numNad={numNad}
                      task={
                        taskNumberPost.filter((el) => el.guid === numNad)
                          .length > 0
                          ? {
                              id: taskNumberPost.filter(
                                (el) => el.guid === numNad
                              )[0].taskId,
                            }
                          : ""
                      }
                      desc={
                        descPost.filter((el) => el.guid === numNad).length > 0
                          ? descPost.filter((el) => el.guid === numNad)[0].desc
                          : ""
                      }
                    />
                  </>
                ) : (
                  ""
                )}
                {showDetails ? (
                  <>
                    <ShowPostDetail
                      close={() => {
                        setShowDetails(false);
                      }}
                      numNad={numNad}
                      task={
                        taskNumberPost.filter((el) => el.guid === numNad)
                          .length > 0
                          ? {
                              id: taskNumberPost.filter(
                                (el) => el.guid === numNad
                              )[0].taskId,
                            }
                          : ""
                      }
                      desc={
                        descPost.filter((el) => el.guid === numNad).length > 0
                          ? descPost.filter((el) => el.guid === numNad)[0].desc
                          : ""
                      }
                    />
                  </>
                ) : (
                  ""
                )}
                {showTask ? (
                  <>
                    <TaskPopUp
                      taskID={showTaskId}
                      hearingsData={props.hearingsData}
                      tasksData={props.tasksData}
                      tasksSheetData={props.tasksSheetData}
                      closeTaskPopUp={() => setShowTask(false)}
                      lawyersData={props.lawyersData}
                      refreshData={props.refreshData}
                      user={props.uData}
                      courtsData={props.courtsData}
                      banksData={props.banksData}
                      usersData={props.users}
                      resultsData={props.resultsData}
                      tasksTypesData={props.tasksTypesData}
                      history={false}
                      checkPermissions={props.checkPermissions}
                      team={props.team}
                      hearingsTeam2Data={props.hearingsTeam2Data}
                      hearingsTeam2SheetData={props.hearingsTeam2SheetData}
                      tasksTeam2Data={props.tasksTeam2Data}
                      tasksTeam2SheetData={props.tasksTeam2SheetData}
                      archTasksTeam2={props.tasksArchTeam2SheetData}
                      archTasks={props.archTasks}
                      logClientAction={props.logClientAction}
                      close={() => setShowTask(false)}
                      tabIndex={0}
                      clientsData={props.clientsFullData}
                      filesData={props.filesData}
                      user={props.user}
                    />
                  </>
                ) : (
                  <>
                    <div
                      id="asd1"
                      style={{
                        marginTop: "0",
                        marginBottom: "5vh",
                      }}
                    >
                      <div style={{ marginTop: "5px" }} className="inputBox">
                        <div id="asd" className="inputCol_2">
                          <label style={{ fontSize: "1vw" }}>
                            Numer przesyłki, adres, nazwa, opis, zadanie
                          </label>
                          <input
                            style={{ height: "3vh" }}
                            type="text"
                            id="name"
                            name="name"
                            value={contentFilter}
                            onChange={(e) => {
                              setContentFilter(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                      <div
                        style={{
                          marginTop: "2vh",
                          display: "flex",
                          gap: "10px",
                        }}
                      >
                        <button
                          style={{
                            backgroundColor: "#00bdce",
                            border: "none",
                            color: "white",
                            fontWeight: "600",
                            borderRadius: "15px",
                          }}
                          id="clientsFilterButton"
                          className="paymentMenuButton"
                          onClick={getFilteredBuffer}
                        >
                          Pokaż
                        </button>
                        <button
                          style={{
                            backgroundColor: "#00bdce",
                            border: "none",
                            color: "white",
                            fontWeight: "600",
                            borderRadius: "15px",
                          }}
                          id="clientsFilterButton"
                          className="paymentMenuButton"
                          onClick={clearFilters}
                        >
                          WYCZyŚĆ
                        </button>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        gap: "2vw",
                        marginBottom: "5vh",
                      }}
                    >
                      {closeSend ? (
                        <>
                          <button
                            className="paymentMenuButton"
                            onClick={fetchOpenSend}
                          >
                            OTWÓRZ WYSYŁKĘ NA DZIŚ
                          </button>
                        </>
                      ) : (
                        <>
                          <button
                            className="paymentMenuButton"
                            style={{
                              backgroundColor: "red",
                              color: "white",
                              border: "white",
                            }}
                            onClick={fetchCreateBufor}
                          >
                            ZAMKNIJ WYSYŁKĘ NA DZIŚ
                          </button>
                        </>
                      )}
                    </div>
                    {buffer.length === 0 ? (
                      <>BRAK PRZESYŁEK W BUFORZE</>
                    ) : (
                      <>{bufferData}</>
                    )}
                  </>
                )}
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default PostBookBuffer;
